import React from "react";
import "../Css/childrenhelp.css";
import SafetyNurture from "../Img/Icons/Safety&Nurture.png";
import Belongingimg from "../Img/Icons/Belonging-and-Therapeutic.png";
import traumaProcessing from "../Img/Icons/TraumaProcessing.png";
import OwnNurtureCarers from "../Img/Icons/Own-Nurture-Carers.png";
import ClinicalAssessment from "../Img/Icons/Clinical-Assessment.png";
import TherapyAccesse from "../Img/Icons/Therapy-Access.png";
function Childrenhelp() {
  return (
    <>
      <div className="children-help">
        <div className="container">
          <div className="breadcrumb-container">
            <ul className="breadcrumbs">
              <li>
                <a href="/">Home</a>
              </li>
              <li>How We Help Our Children</li>
            </ul>
          </div>

          <h2 className="banner-heading">Children Help</h2>
        </div>
      </div>

      <section className="py-5">
        <div className="container">
          <p className=" text-center pb-4">
            Affinity Childrens Services Limited provides residential placements
            and therapeutic care for children and young people in our homes in
            the West Midlands region. Placements can be provided on a planned or
            emergency basis, depending on the specific needs of the person in
            question. Our clinical team consists of Directors, registered and
            chartered psychologists, therapeutic life story practitioners, these
            individuals allow in-depth, tailored therapeutic care, helping them
            navigate and progress through their trauma. Our team of
            Psychologists and Therapists have years of experience providing
            various therapies from a trauma-informed attachment aware and
            brain-based perspective.
          </p>
          <div className="row g-4"></div>
        </div>

        <div className="container py-5">
          <div className="row g-4">
            {/* Card 1 */}
            <div className="col-md-4">
              <div className="icon-card">
                <div className="icon-box">
                  <i className="bi bi-house-heart-fill" />
                  <img
                    src={SafetyNurture}
                    alt="Safety Nurture"
                    className="icon-w"
                  />
                </div>
                <h5 className="mt-3">Safety & Nurture</h5>
                <p>
                  We help our children by providing safety and nurture to all
                  aspects of their lives, we know that this is the absolute
                  foundation that our children require, and therefore ensure
                  this is woven into each aspect of the care we provide and in
                  the children’s day to day lived experiences with us.
                </p>
              </div>
            </div>
            {/* Card 2 */}
            <div className="col-md-4">
              <div className="icon-card">
                <div className="icon-box">
                  <i className="bi bi-book-half" />
                  <img
                    src={Belongingimg}
                    alt="Safety Nurture"
                    className="icon-w"
                  />
                </div>
                <h5 className="mt-3">Belonging and Therapeutic Parenting</h5>
                <p>
                  It is essential for our children to be able to feel that they
                  belong, that they are wanted, that they are accepted for who
                  they are and that this is embraced within their home. Our
                  nurture team provide this through the therapeutic care and
                  re-parenting they deliver to each child under our care.
                </p>
              </div>
            </div>
            {/* Card 3 */}
            <div className="col-md-4">
              <div className="icon-card">
                <div className="icon-box">
                  <i className="bi bi-emoji-smile-fill" />
                  <img
                    src={traumaProcessing}
                    alt="Safety Nurture"
                    className="icon-w"
                  />
                </div>
                <h5 className="mt-3">Trauma Processing</h5>
                <p>
                  We help our children to process their trauma experiences
                  through a variety of therapeutic methods tailored to their
                  needs and their specific experiences. This allows our children
                  to progress with their lives, understand who they are and look
                  forward to a stable and brighter future.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="Own-Nurture-Carers py-5">
        <div className="container">
          <h2 class="sub-heading text-center">Each Child Placed with us Has</h2>
          <div className="row g-4 mt-4">
            {/* Card 1 */}
            <div className="col-md-4">
              <div className="icon-card">
                <div className="icon-box">
                  <i className="bi bi-house-heart-fill" />
                  <img
                    src={OwnNurtureCarers}
                    alt="Safety Nurture"
                    className="icon-w"
                  />
                </div>
                <h5 className="mt-3">Their Own Nurture Carers</h5>
                <p>
                  At Affinity Childrens, every child is supported by a dedicated
                  care team. Our trained carers provide daily emotional and
                  behavioural guidance using child-focused, trauma-aware
                  support.
                </p>
              </div>
            </div>
            {/* Card 2 */}
            <div className="col-md-4">
              <div className="icon-card">
                <div className="icon-box">
                  <i className="bi bi-book-half" />
                  <img
                    src={ClinicalAssessment}
                    alt="Safety Nurture"
                    className="icon-w"
                  />
                </div>
                <h5 className="mt-3">Clinical Assessment And Outcomes</h5>
                <p>
                  We provide a full clinical assessment of every child placed
                  with us so we can explore their strengths, risks and needs.
                  our children over a 12 week period and let these findings
                  guide their therapeutic care plan and clinical requirements.
                </p>
              </div>
            </div>
            {/* Card 3 */}
            <div className="col-md-4">
              <div className="icon-card">
                <div className="icon-box">
                  <i className="bi bi-emoji-smile-fill" />
                  <img
                    src={TherapyAccesse}
                    alt="Safety Nurture"
                    className="icon-w"
                  />
                </div>
                <h5 className="mt-3">Therapy Access</h5>
                <p>
                  We ensure every child placed with us has access to therapy
                  when it meets their clinical needs. All support is
                  trauma-informed and may include DDP, EMDR, Therapeutic Life
                  Story (TLS), and Trauma-Focused CBT (T-CBT).
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Childrenhelp;
